import React from 'react';
import { useTranslation } from 'next-i18next';
import { Link, LogoIcon, XIcon } from '@/components';
import { PagePath } from '@/layouts/shared';

type Props = {
  conversationId?: number;
  product?: boolean;
  floating?: boolean;
  busy?: boolean;
  canCreate?: boolean;
  onNew?: () => void;
  onInbox?: () => void;
  onClose?: () => void;
  onMinimize?: () => void;
};

/** Shared brand bar for the floating chat and mobile conversation. */
export const ConsultationHeader = ({ conversationId, product, floating = true, busy, canCreate = true, onNew, onInbox, onClose, onMinimize }: Props) => {
  const { t } = useTranslation('layout');
  return (
    <div className={`consult-chrome ${floating ? 'consult-chrome-floating' : 'consult-chrome-page'}`}>
      <header className="consult-brand-bar">
        {!floating && <Link url={PagePath.ConsultListChatPage} className="consult-chrome-back" title={t('consultPopup.conversations')}>←</Link>}
        <span className="consult-chrome-logo"><LogoIcon width="84" height="30" /></span>
        <div className="consult-chrome-title"><strong>{t('consultPopup.adviceTitle')}</strong><span>{t(product ? 'consultPopup.productSubtitle' : 'consultPopup.generalSubtitle')}</span></div>
        {!floating && <Link url={PagePath.ConsultListChatPage} className="consult-chrome-close" title={t('consultPopup.close')}><XIcon className="tw-w-4 tw-h-4" /></Link>}
        {floating && <div className="consult-chrome-controls">
          <button type="button" onClick={onMinimize || onClose} aria-label={t('consultPopup.minimize')}>−</button>
          {conversationId && <Link url={{ pathname: PagePath.ConsultChatPage, query: { id: conversationId } }} title={t('consultPopup.expand')}>⛶</Link>}
          <button type="button" onClick={onClose} aria-label={t('consultPopup.close')}><XIcon className="tw-w-4 tw-h-4" /></button>
        </div>}
      </header>
      <nav className="consult-chrome-nav" aria-label={t('consultPopup.conversations')}>
        <button type="button" disabled={busy || !canCreate} onClick={onNew}><span aria-hidden="true">＋</span>{t('consultPopup.newConversation')}</button>
        {onInbox ? <button type="button" onClick={onInbox}>{t('consultPopup.yourConversations')} <span aria-hidden="true">→</span></button> : <Link url={PagePath.ConsultListChatPage}>{t('consultPopup.yourConversations')} <span aria-hidden="true">→</span></Link>}
      </nav>
    </div>
  );
};
